"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Range_1 = __importDefault(require("../Util/Range"));
const mostRecentStartOfWeek_1 = __importDefault(require("../Util/mostRecentStartOfWeek"));
const endOfWeekAfter_1 = __importDefault(require("../Util/endOfWeekAfter"));
const asyncIterate_1 = __importDefault(require("../Util/asyncIterate"));
const byDateSort_1 = __importDefault(require("./byDateSort"));
class Recovery {
    constructor(adapter, dateTimeProvider, cache, dateTimeBridge) {
        this.getDateRange = async (customerId, dateRange) => {
            const sysRange = this.dateTimeBridge.systemRange(dateRange);
            const { days, disabledChecklistItems } = await this.cache.getRange(sysRange, customerId, async () => {
                const { days, disabledChecklistItems } = await this.adapter.getDateRange(customerId, sysRange);
                return {
                    days: days
                        .map((day) => ({
                        ...day,
                        day: this.dateTimeProvider.dayOfWeek(this.dateTimeBridge.userDate(day.date)),
                    }))
                        .sort(byDateSort_1.default),
                    disabledChecklistItems,
                };
            });
            return {
                days: await (0, asyncIterate_1.default)(days.filter(this.dayExist), async (day) => {
                    return {
                        ...day,
                        date: this.dateTimeBridge.userDate(day.date),
                    };
                }),
                disabledChecklistItems,
            };
        };
        this.dayExist = (day) => Boolean(day);
        this.getDate = async (customerId, date) => {
            const dateRangeResult = await this.getDateRange(customerId, new Range_1.default(this.dateTimeBridge.userDate((0, mostRecentStartOfWeek_1.default)(this.dateTimeBridge.systemDate(date))), this.dateTimeBridge.userDate((0, endOfWeekAfter_1.default)(this.dateTimeBridge.systemDate(date)))));
            return dateRangeResult.days.find((day) => day.date === date);
        };
        this.adapter = adapter;
        this.dateTimeProvider = dateTimeProvider;
        this.cache = cache;
        this.dateTimeBridge = dateTimeBridge;
    }
}
exports.default = Recovery;
//# sourceMappingURL=Recovery.js.map